import React, { Component } from 'react';
import OrderGroup from './OrderGroup';
import { connect } from 'react-redux';
import * as ordersActions from '../../actions/orderActions';
import { bindActionCreators } from 'redux';
import { getOrdersByStatus } from '../../reducers/index';

class OrdersPage extends Component {
  componentDidMount() {
    this.props.listenToIncomingOrders();
    this.props.listenToAuditedOrders();
    this.props.listenToReadyToShipOrders();
    this.props.listenToShippedOrders();
    this.props.listenToArchivedOrders();
  }

  componentWillUnmount() {
    this.props.silenceIncomingOrders();
    this.props.silenceAuditedOrders();
    this.props.silenceReadyToShipOrders();
    this.props.silenceShippedOrders();
    this.props.silenceArchivedOrders();
  }

  render() {
    return (
      <div>
        <h1 className="display-4">Orders</h1>
        {!!this.props.incoming.length && (
          <OrderGroup
            title="Incoming"
            description="Orders that have not completed audit."
            orders={this.props.incoming}
          />
        )}
        {!!this.props.audited.length && (
          <OrderGroup
            title="Audited"
            description="Orders that have been audited and are awaiting shipping label."
            orders={this.props.audited}
          />
        )}
        {!!this.props.readyToShip.length && (
          <OrderGroup
            title="Ready to Ship"
            description="Orders that have a shipping label and are ready to ship."
            orders={this.props.readyToShip}
          />
        )}
        {!!this.props.shipped.length && (
          <OrderGroup
            title="Shipped"
            description="Shipped orders that are awaiting delivery."
            orders={this.props.shipped}
          />
        )}
        {!!this.props.archived.length && (
          <OrderGroup
            title="Recently Archived"
            description="Recent orders that have been completed and are now archived."
            orders={this.props.archived}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    incoming: getOrdersByStatus(state, 'incoming'),
    audited: getOrdersByStatus(state, 'audited'),
    readyToShip: getOrdersByStatus(state, 'readyToShip'),
    shipped: getOrdersByStatus(state, 'shipped'),
    archived: getOrdersByStatus(state, 'archived')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ordersActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OrdersPage);



// WEBPACK FOOTER //
// ./src/components/orders/OrdersPage.js